var _style, _g, _g2, _defs, _ellipse, _path, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertViewicona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.2 197.2",
    style: {
      enableBackground: "new 0 0 197.2 197.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:2.58;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st1{fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:18.59;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st2{clip-path:url(#SVGID_00000073718214830126921060000013937405935529402558_);}\n\t\n\t\t.st3{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:9.24;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    xmlnsSerif: "http://www.serif.com/"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10885,0,0,0.985936,-1173.47,1.02619)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1209.4,31.1c0-6.1-4.4-11-9.8-11h-102.7c-5.4,0-9.8,4.9-9.8,11v153.6c0,6.1,4.4,11,9.8,11h102.7 c5.4,0,9.8-4.9,9.8-11V31.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.4,9.9L75.5,9.9c-5,0-9.1,4.1-9.1,9.1l0,17.9c0,5,4.1,9.1,9.1,9.1l47.9,0.1c5,0,9.1-4.1,9.1-9.1l0-17.9 C132.5,14,128.4,10,123.4,9.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33049,0,0,1.37557,-208.863,-301.69)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 201,
    y: 217.1,
    width: 61.4,
    height: 20.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000135664035181958428450000018255926276707628681_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000135664035181958428450000018255926276707628681_)"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 231.8,
    cy: 234.8,
    rx: 11.4,
    ry: 10.9
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.8,108.7l22.4,23.5l37.9-38.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertViewicona);
export default __webpack_public_path__ + "static/media/alertViewicona.a27b8d9e6cc83dc7bcf3c9cbe8a1cd4d.svg";
export { ForwardRef as ReactComponent };